export default {
  List: {
    title: "Nhân viên",
    AddButton: "Thêm mới",
    Search: "Tìm kiếm nhân viên",
    EmployeeCode: "Mã nhân viên",
    EmployeeName: "Tên nhân viên",
    OrganizationUnit: "Phòng ban",
    FullName: "Tên nhân viên",
    EmployeeStatusName: "Phân loại",
    JobPositionName: "Vị trí công việc",
    ReportTo: "Quản lý trực tiếp",
    Inactive: "Trạng thái",
    CareerTitle: "Chức danh",
    Gender: "Giới tính",
    PhoneNumber: "Số điện thoại",
    Email: "Email",
    AssetUsing: "TS đang sử dụng",
    AssetManaging: "TS đang quản lý",
    ActiveStatus: "Trạng thái lao động",
    SynchFromAMIS: "Đồng bộ từ AMIS",
    SynchFromAMISTitle: "Đồng bộ từ AMIS hệ thống",
    WorkingRun: "Đang thực hiện đồng bộ dữ liệu từ Amis hệ thống",
    SynchSuccess: "Đồng bộ thành công",
    AssetRepresent: "TS đại diện nhận",
  },
  Detail: {
    Add: "Thêm mới nhân viên",
    Edit: "Sửa nhân viên",
    Status: "Tình trạng",
    EmployeeInformation: "Thông tin nhân viên",
  },
  AllocationReduceListDetail: {
    AssetReceive: "Tài sản đại diện nhận",
    UsageProcess: "Quá trình sử dụng",
    UsingAsset: "Tài sản đang sử dụng",
    CommonInfor: "Thông tin chung",
  },
};
